const FRAUD_SID_KEY = 'fraud_sid';
const FRAUD_SID_USED_KEY = 'fraud_sid_used';

let memorySid = null;

const generate = () => (window.crypto?.randomUUID?.()
  ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`);

const readAnyStore = () => {
  try {
    if (memorySid) return memorySid;
    return localStorage.getItem(FRAUD_SID_KEY) ?? sessionStorage.getItem(FRAUD_SID_KEY);
  } catch {
    return memorySid;
  }
};

const writeAllStores = (sid) => {
  memorySid = sid;
  try {
    localStorage.setItem(FRAUD_SID_KEY, sid);
  } catch {
    // storage unavailable — the in-memory copy still carries this page load
  }
  try {
    sessionStorage.setItem(FRAUD_SID_KEY, sid);
  } catch {
    // storage unavailable
  }
};

export function getOrCreateFraudSid() {
  const existing = readAnyStore();
  if (existing) {
    writeAllStores(existing); // re-heal any store that was wiped
    return existing;
  }

  const sid = generate();
  writeAllStores(sid);
  return sid;
}

/** Checkout finished — the next one starts clean. */
export function resetFraudSid() {
  memorySid = null;
  try {
    localStorage.removeItem(FRAUD_SID_KEY);
    localStorage.removeItem(FRAUD_SID_USED_KEY);
  } catch {
    // storage unavailable
  }
  try {
    sessionStorage.removeItem(FRAUD_SID_KEY);
  } catch {
    // storage unavailable
  }
}

/**
 * Record that the current sid has been committed to an order. Only the marker's presence
 * drives rotation; the value is kept for debugging.
 */
export function markFraudSidUsed(orderKey = true) {
  try {
    localStorage.setItem(FRAUD_SID_USED_KEY, String(orderKey));
  } catch {
    // storage unavailable
  }
}

/**
 * Rotate to a fresh sid ONLY if the current one already made an order, so the first order of
 * a checkout keeps the beacon's full pre-submit history while a retry gets a clean sid.
 *
 * @returns {boolean} whether the sid was rotated
 */
export function rotateFraudSidIfUsed() {
  let used = null;
  try {
    used = localStorage.getItem(FRAUD_SID_USED_KEY);
  } catch {
    // storage unavailable — treat as unused
  }

  if (used === null) return false;

  resetFraudSid();
  getOrCreateFraudSid();
  return true;
}

/** Adopt a sid already committed server-side (recovery). */
export function adoptFraudSid(sid) {
  if (sid) writeAllStores(sid);
}
